import { render } from "./uiFormTextarea.vue?vue&type=template&id=e5f28b04"
import script from "./uiFormTextarea.vue?vue&type=script&lang=js"
export * from "./uiFormTextarea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__